/*#__PURE__*/ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { MetamaskSnap } from "./snap";
import { checkSnapSupport, isMetamaskInstalled } from "./utils";
import versionJson from "./version.json";
export { MetamaskSnap } from "./snap";
export * from "./types";
export { isMetamaskInstalled, isSnapInstalled } from "./utils";
export const defaultSnapOrigin = 'npm:@rarimo/rarime';
export const enableSnap = function() {
    var _ref = _async_to_generator(function*(snapOrigin, version = versionJson.version) {
        const snapId = snapOrigin !== null && snapOrigin !== void 0 ? snapOrigin : defaultSnapOrigin;
        if (!(yield isMetamaskInstalled())) {
            throw new Error('Metamask is not installed');
        }
        if (!(yield checkSnapSupport())) {
            throw new Error('Current version of MetaMask is not supported');
        }
        yield window.ethereum.request({
            method: 'wallet_requestSnaps',
            params: {
                [snapId]: _object_spread({}, version && {
                    version
                })
            }
        });
        return new MetamaskSnap(snapId);
    });
    return function enableSnap(snapOrigin) {
        return _ref.apply(this, arguments);
    };
}();

//# sourceMappingURL=index.js.map